import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { HOME_PATH } from '../../constants/sessionRoute.constants';
import { hasFlightSearchQuery } from './hasFlightSearchQuery';

class RequireFlightSearch extends React.Component {
  render() {
    if (!hasFlightSearchQuery(this.props.searchParams)) {
      return <Navigate to={HOME_PATH} replace />;
    }
    return this.props.children;
  }
}

export function RequireFlightSearchRoute({ children }) {
  const [searchParams] = useSearchParams();
  return (
    <RequireFlightSearch searchParams={searchParams}>
      {children}
    </RequireFlightSearch>
  );
}

export default RequireFlightSearch;
